import { useMemo } from "react";

import { useListRunners, type PlainRunner } from "@/queries/runner-queries";
import { RunnerKind } from "gitpod-next-api/gitpod/v1/runner_configuration_pb";

export function useAvailableRunners({ enabled }: { enabled: boolean } = { enabled: true }) {
    const { data: remoteRunners, isPending } = useListRunners({ kind: RunnerKind.REMOTE });

    const availableRunners = useMemo<PlainRunner[]>(() => {
        if (!enabled || isPending) {
            return [];
        }
        return remoteRunners || [];
    }, [enabled, isPending, remoteRunners]);

    return {
        isLoading: isPending,
        availableRunners,
    };
}
